import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './crm.notes.slice';

const crmNoteSlice = (state) => state.notes || initialState;
export const selectIsUpdateCrmNotes = createSelector(
	[crmNoteSlice],
	(state) => state.isUpdateCrmNote,
);
export const selectCRMnotes = createSelector([crmNoteSlice], (state) => state.CRMnotes);
